import _ from 'underscore'

export default {

	namespaced: true,

	modules: {},

	state: {

		data: []

	},

	getters: {

		list: function(state) {

			return _.sortBy(state.data, 'mechanic_name')

		},

		associated: function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.mechanic_id] = item

			})

			return associated

		}

	},

	mutations: {

		add: function(state, items) {

			_.each(items, function(item) {

				if (!_.contains(_.pluck(state.data, 'mechanic_id'), item.mechanic_id)) {

					state.data.push(item)

				}

			})

		}

	},

	actions: {}

}
